import axios from 'axios';

export const updateVerificationStatus = async (verification_id, userToken,) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}veriff/updateVerificationStatus`,
            { id: verification_id, token: userToken, status: "approved" } // Send id and status as the request body
        );
    
        // return response.data; // Return the response from the server
    } catch (error) {
        throw error.response.data; // Handle errors appropriately
    }
};

export const sendVerificationReminder = async (userToken) => {
    try {
        if (!userToken) {
            throw new Error('User token is required');
        }

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}notifications/send-verification-reminder`,
            { token: userToken }
        );
         return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const sendVerificationSuccessNotification = async (userToken, userId = null) => {
    try {
        if (!userToken) {
            throw new Error('User token is required');
        }

        const payload = { token: userToken };
        if (userId) {
            payload.userId = userId;
        }

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}notifications/send-verification-success`,
            payload
        );
         return response.data;
    } catch (error) {
        console.error('Error sending verification success notification:', error);
        throw error.response?.data || error;
    }
};

export const sendVerificationCancellationNotification = async (userToken, userId = null) => {
    try {
        if (!userToken) {
            throw new Error('User token is required');
        }

        const payload = { token: userToken };
        if (userId) {
            payload.userId = userId;
        }

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}notifications/send-verification-cancellation`,
            payload
        );
         return response.data;
    } catch (error) {
        console.error('Error sending verification cancellation notification:', error);
        throw error.response?.data || error;
    }
};